<script>
  import { onMount } from "svelte";
  import rough from "roughjs/bundled/rough.cjs";

  export let selectedRoom;

  const desks = [
    { x: 45, y: 20, width: 20, height: 40 },
    { x: 45, y: 65, width: 20, height: 40 },
    { x: 70, y: 20, width: 20, height: 40 },
    { x: 70, y: 65, width: 20, height: 40 },
    { x: 47, y: 110, width: 40, height: 20 },
    { x: 150, y: 20, width: 20, height: 40 },
    { x: 150, y: 65, width: 20, height: 40 },
    { x: 175, y: 20, width: 20, height: 40 },
    { x: 175, y: 65, width: 20, height: 40 },
    { x: 152, y: 110, width: 40, height: 20 },
    { x: 255, y: 20, width: 20, height: 40 },
    { x: 255, y: 65, width: 20, height: 40 },
    { x: 280, y: 20, width: 20, height: 40 },
    { x: 280, y: 65, width: 20, height: 40 },
    { x: 257, y: 110, width: 40, height: 20 },
    { x: 135, y: 190, width: 40, height: 20 },
    { x: 180, y: 190, width: 40, height: 20 },
    { x: 135, y: 215, width: 40, height: 20 },
    { x: 180, y: 215, width: 40, height: 20 },
    { x: 225, y: 192, width: 20, height: 40 },
  ];

  let selectedTable = -1;

  function paintRoom() {
    const roomSvg = document.getElementById("room-svg");
    while (roomSvg.firstChild) {
      roomSvg.removeChild(roomSvg.lastChild);
    }
    const rc = rough.svg(roomSvg);
    let node = rc.rectangle(10, 10, 320, 320, { strokeWidth: 1.2 }); // x, y, width, height
    roomSvg.appendChild(node);

    desks.forEach((desk, index) => {
      let tabelNode = rc.rectangle(desk.x, desk.y, desk.width, desk.height, {
        fill: "#fff",
        fillStyle: "solid",
        stroke: selectedTable === index ? "green" : "rgb(59, 130, 246)",
        strokeWidth: 0.5,
      });
      tabelNode.addEventListener("click", () => {
        selectedTable = index;
        paintRoom();
      });
      roomSvg.appendChild(tabelNode);
    });
  }

  onMount(() => {
    paintRoom();
  });
</script>

<style>
  svg {
    width: 100%;
    height: auto;
  }
</style>

<div>
  <h2>You are in Room {selectedRoom}</h2>
  <svg id="room-svg" viewBox="0 0 340 340" />
</div>
